import React, { useCallback } from "react";
import { useAddHomework } from '@widgets/appointment/api/useAddHomework';
import { MaterialComposer } from "@widgets/appointment/ui/material-composer/material-composer";

export const AddHomeworkCard = ({appointmentId, startExpanded = false}) => {
	const {mutateAsync: createHomework} = useAddHomework(appointmentId)

	const handleSubmit = useCallback(
		({ text, attachments, existingFileIds }) =>
		createHomework({appointmentId, 
			data: {
				task: text || null
			},
			attachments,
			filesId: existingFileIds
		}),
		[appointmentId, createHomework]
	)

  return (
    <MaterialComposer
			addButtonLabel="Добавить домашнее задание"
			startExpanded={startExpanded}
			onSubmit={handleSubmit}
		/>
  );
};
